module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-bretzel.a13daf03.jpg";